import api from "@/api.js";

export default {
  namespaced: true,
  modules: {},
  state: {
    data: [],
    dataLoading: false,
  },
  mutations: {
    setData(state, payload) {
      state.data = payload;
    },
    setDataLoading(state, payload) {
      state.dataLoading = payload;
    },
  },
  actions: {
    async load({ commit }, params = null) {
      commit("setDataLoading", true);
      let data = await api.get("sustainability/extraBusinessInfo", params);
      commit("setData", data.data);
      commit("setDataLoading", false);
    },
    async saveAnnualRevenue({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`sustainability/updateAnnualRevenue`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });

      dispatch(
        "load",
        payload.year
          ? {
              params: {
                year: payload.year,
              },
            }
          : null
      );
      return returnData;
    },
  },
  getters: {
    data(state) {
      return state.data;
    },
    dataLoading(state) {
      return state.dataLoading;
    },
  },
};
